import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import FormHelperText from "@material-ui/core/FormHelperText";
import { SessionContext } from "beaktShared/services/session";

// icons
import PermIdentity from "@material-ui/icons/PermIdentity";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Clearfix from "beaktShared/components/Clearfix/Clearfix.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";

import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function ProfissaoForm({ addItem, item, handleView, loading }) {
    const { t } = useTranslation();
    const session = useContext(SessionContext);
    const classes = useStyles();
    const { register, handleSubmit, setValue, errors } = useForm({mode: "onChange"});
    const [ativoCheckbox, setAtivoCheckbox] = React.useState(true);

    const intialValues = {
        id:0,
        descricao:'',
        ativo:true
    };
    
    useEffect(() => {
        if(!item.profissaoId)
            return;    
        setValue('id', item.profissaoId);     
        setValue('descricao', item.descricao);       
        setAtivoCheckbox(item.ativo);
    }, [item]);

    const onSubmit = data => {
        addItem({
            profissaoId:parseInt(data.id),
            descricao:data.descricao,
            ativo:ativoCheckbox,
            usuarioCadastroId:session.id,
            estabelecimentoId: session.estabelecimentoId

        });        
    };

    const handleViewForm = () => {
        handleView();
    };

    return (
        <div className="maxContent">              
            <form onSubmit={handleSubmit(onSubmit)}>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <PermIdentity />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>
                                {t('sidebar.profession_register')} 
                                <input className={classes.hidden} defaultValue={intialValues.id} name="id" ref={register} />
                            </h4>
                        </CardHeader>
                        <CardBody>                            
                            <GridContainer>
                                <GridItem xs={12} sm={6} md={6}> 
                                    <FormControl fullWidth className={classes.formControl}>                               
                                    <TextField                                        
                                        error={errors.descricao?true:false}
                                        label={t('label.description')+" *"}
                                        variant="outlined"                                    
                                        inputRef={register({required: true})}
                                        name="descricao"
                                        defaultValue={intialValues.descricao}  
                                        InputLabelProps={{shrink: true}}   
                                        inputProps={{maxLength: 50}}                          
                                    />
                                    <FormHelperText className={classes.labelRootError}>
                                        {errors.descricao && <span>{t('label.required')}</span>}
                                    </FormHelperText>   
                                    </FormControl>                                 
                                </GridItem>
                            </GridContainer>
                            <GridContainer>                               
                                <GridItem xs={12} sm={12} md={4}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                tabIndex={-1}                                                
                                                checked={ativoCheckbox}   
                                                onClick={event => {setAtivoCheckbox(event.target.checked)}}                                             
                                                checkedIcon={<Check className={classes.checkedIcon} />}
                                                icon={<Check className={classes.uncheckedIcon} />}
                                                classes={{
                                                    checked: classes.checked,
                                                    root: classes.checkRoot
                                                }}                    
                                                name="ativo"  
                                                inputRef={register}                                                    
                                            />
                                        }
                                        classes={{
                                            label: classes.label,
                                            root: classes.labelRoot
                                        }}
                                        label={t('information_message.system_active')}
                                    />
                                </GridItem>
                            </GridContainer>
                            <Clearfix />
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12} className={classes.textCenter}>
                    <div className={classes.textCenter}>
                        <Button  onClick={() => handleViewForm()} color="transparent" className={classes.updateProfileButton}>
                            {t('button.cancel')}
                        </Button>
                        <Button type="submit" color="primary" className={classes.updateProfileButton}>
                            {t('button.to_save')} 
                            {loading && <div>{t('label.loading')+"..."}</div>}
                        </Button>
                    </div>
                </GridItem>
            </GridContainer>            
            </form>
        </div>
    );
}